// extracted by mini-css-extract-plugin
export default {"loadMoreButton":"AnimalList_loadMoreButton__gsQ2z"};